'use strict';

var _createForOfIteratorHelper = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _require = require('buffer'),
    Buffer = _require.Buffer;

module.exports = function base64(alphabet) {
  // The alphabet is only used to know:
  //   1. If padding is enabled (must contain '=')
  //   2. If the output must be url-safe (must contain '-' and '_')
  //   3. If the input of the output function is valid
  // The alphabets from RFC 4648 are always used.
  var padding = alphabet.indexOf('=') > -1;
  var url = alphabet.indexOf('-') > -1 && alphabet.indexOf('_') > -1;
  return {
    encode: function encode(input) {
      var output = '';

      if (typeof input === 'string') {
        output = Buffer.from(input).toString('base64');
      } else {
        output = input.toString('base64');
      }

      if (url) {
        output = output.replace(/\+/g, '-').replace(/\//g, '_');
      }

      var pad = output.indexOf('=');

      if (pad > 0 && !padding) {
        output = output.substring(0, pad);
      }

      return output;
    },
    decode: function decode(input) {
      var _iterator = _createForOfIteratorHelper(input),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var char = _step.value;

          if (alphabet.indexOf(char) < 0) {
            throw new Error('invalid base64 character');
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return Buffer.from(input, 'base64');
    }
  };
};